  const shopSelector = document.querySelector('[data-shop-selector]');
  const shopSelectorCloseButtons = shopSelector.querySelectorAll('[data-close]');
  const shopListElement = shopSelector.querySelector('[data-shop-list]');

  document.addEventListener('shopselector:open', () => {
    shopSelector.setAttribute('data-active', 'true');
  });

  shopSelectorCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      shopSelector.setAttribute('data-active', 'false');
    });
  });

  theme.shops.forEach((shop) => {
    if (shop.hidden) return;
    const currentParams = new URLSearchParams(window.location.search);
    let currentPath = window.location.pathname;

    //Remove localization from path
    theme.shops.forEach((shop_nested) => {
      if (shop_nested.subdomain) {
        currentPath = currentPath.replace(`/${shop_nested.subdomain}`, '');
      }
    });

    const href = `${shop.url}${shop.subdomain ? `/${shop.subdomain}` : ''}${currentPath}${
      currentParams.toString() != '' ? `?${currentParams.toString()}` : ''
    }`;
    const html = `
        <li>
          <a class="shop-selector__list--item" href="${href}">
            <div class="shop-selector__list--item--country">
              <div class="shop-selector__list--item--icon">
                ${shop.icon}
              </div>
              <p class="letter__capitals">${shop.title}</p>
            </div>
            <p class="shop-selector__list--item--currency">${shop.currency}</p>
          </a>
        </li>
      `;

    shopListElement.insertAdjacentHTML('beforeend', html);
  });

  const getLocaleData = async () => {
    const request = await fetch(
      window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}`
    ).then((r) => r.json());

    return request;
  };

  const currentParams = new URLSearchParams(window.location.search);

  const shopSuggestion = document.querySelector('[data-shop-suggestion]');
  const shopSuggetionCloseButtons = shopSuggestion.querySelectorAll('[data-close]');
  const shopSuggestionListElement = shopSuggestion.querySelector('[data-suggestion-list]');

  const closeShopSuggestion = () => {
    shopSuggestion.setAttribute('data-active', 'false');
  };

  shopSuggetionCloseButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closeShopSuggestion();
    });
  });

  const showShopSelectorPopup = (currentShop, suggestedShop) => {
    const currentParams = new URLSearchParams(window.location.search);
    let currentPath = window.location.pathname;

    //Remove localization from path
    theme.shops.forEach((shop_nested) => {
      if (shop_nested.subdomain) {
        currentPath = currentPath.replace(`/${shop_nested.subdomain}`, '');
      }
    });

    const href = `${suggestedShop.url}${suggestedShop.subdomain ? `/${suggestedShop.subdomain}` : ''}${currentPath}${
      currentParams.toString() != '' ? `?${currentParams.toString()}` : ''
    }`;
    shopSuggestionListElement.insertAdjacentHTML(
      'beforeend',
      `
          <li>
            <a class="shop-suggestion__list--item primary" href="${href}">
              <div class="shop-suggestion__list--item--spacing">
               ${suggestedShop.icon}
              </div>
              <p class="letter__capitals">go to ${suggestedShop.title}</p>
              <div class="shop-suggestion__list--item--spacing"></div>
            </a>
          </li>
        `
    );

    shopSuggestionListElement.insertAdjacentHTML(
      'beforeend',
      `
          <li>
            <button class="shop-suggestion__list--item secondary" onclick="closeShopSuggestion()">
              <div class="shop-suggestion__list--item--spacing">
                ${currentShop.icon}
              </div>
              <p class="letter__capitals">stay on ${currentShop.title}</p>
              <div class="shop-suggestion__list--item--spacing"></div>
            </button>
          </li>
        `
    );

    shopSuggestion.setAttribute('data-active', 'true');
  };

  const getLocalization = async () => {
    const {
      detected_values: {
        country: { handle: visitorCountryISO },
      },
    } = await getLocaleData();
    const currentShopISO = window.Shopify.country;
    const internationalShop = theme.shops.find((shop) => shop.isInternational);
    const currentShop = theme.shops.find((shop) => shop.countryCode == currentShopISO);
    const findShopSuggestion = theme.shops.find((shop) => shop.countryCode == visitorCountryISO);
    if (currentShop == undefined) return;
    if (findShopSuggestion !== undefined) {
      // We found a shop that matches the visitors country
      if (findShopSuggestion.countryCode != currentShopISO) {
        showShopSelectorPopup(currentShop, findShopSuggestion);
      }
    } else {
      // Check if visitor is on the international store
      if (currentShop !== internationalShop) {
        showShopSelectorPopup(currentShop, internationalShop);
      }
    }

    window.sessionStorage.setItem('shopselector:popup', 'true');
  };

  if (!window.sessionStorage.getItem('shopselector:popup')) {
    getLocalization();
  }
